import { render, staticRenderFns } from "./balance-log-details.vue?vue&type=template&id=6dc8fe19&scoped=true&"
import script from "./balance-log-details.vue?vue&type=script&lang=js&"
export * from "./balance-log-details.vue?vue&type=script&lang=js&"
import style0 from "./balance-log-details.vue?vue&type=style&index=0&id=6dc8fe19&prod&lang=scss&"
import style1 from "./balance-log-details.vue?vue&type=style&index=1&id=6dc8fe19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc8fe19",
  null
  
)

export default component.exports